/********************************
 * Global State Definitions
 ******************************** */

import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import callApi from 'lib/callApi';

import { useOnCompanyChangeCAResetAtoms } from './Admin/Dashboard/CADashboard/hooks';
import { useOnCompanyChangeEpResetAtoms } from './Admin/Dashboard/EPDashboard/hooks';
import { useOnCompanyChangeSast2ResetAtoms } from './Admin/Dashboard/SASTDashboard2/hooks';
import { ChartType, DashboardType } from './Admin/Dashboard/types';
import { useOnCompanyChangeWaResetAtoms } from './Admin/Dashboard/WADashboard/hooks';
import { useOnCompanyChangeFindingsResetAtoms } from './Findings/state';

export const companyDataAtom = atom(async () => {
  try {
    const params = {
      limit: 550,
      ordering: 'display_name',
    };

    const responseData = await callApi('companies/all/', 'GET', params);
    return responseData?.data?.results;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return [];
});

const _baseCompanyIdAtom = atomWithStorage<number>('currentCompanyId', -1);
export const currentCompanyAtom = atomWithStorage<string>('currentCompany', '');
export const companyLogoAtom = atomWithStorage<string>('companyLogo', '');

export const companyIdAtom = atom(
  async (get) => {
    const baseCompanyId = get(_baseCompanyIdAtom);
    const companyData = get(companyDataAtom);

    if (baseCompanyId !== -1) return baseCompanyId;

    const firstCompanyId =
      companyData && companyData[0] ? companyData[0].id : -1;
    return firstCompanyId;
  },
  (get, set, newValue: number) => {
    set(_baseCompanyIdAtom, newValue);
  },
);

// export const currentDashboard = atom(Dashboard.WAS)
export const currentDashboardAtom = atomWithStorage(
  'dashboard_type',
  DashboardType.CA,
);
export const currentChartTypeAtom = atomWithStorage<ChartType>(
  'dashboard_chart_type',
  ChartType.Bar,
);
export type HostActiveStatusFilterType = 'active' | 'aging' | 'deleted';

export function useOnCompanyChangeResetAtoms() {
  const resetCaAtoms = useOnCompanyChangeCAResetAtoms();
  const resetEpAtoms = useOnCompanyChangeEpResetAtoms();
  const resetWaAtoms = useOnCompanyChangeWaResetAtoms();
  const resetSast2Atoms = useOnCompanyChangeSast2ResetAtoms();

  // finding listing
  const resetFindingListingAtoms = useOnCompanyChangeFindingsResetAtoms();

  const resetHosts = () => {
    resetCaAtoms();
    resetEpAtoms();
    resetWaAtoms();
    resetSast2Atoms();
    resetFindingListingAtoms();
  };

  return resetHosts;
}
